import React from 'react';
import { observer } from 'mobx-react';

import { Card } from 'core/components/card';
import { useStore } from 'core/store';
import { Label } from 'core/components/label';
import ValueField from 'core/components/value-field';
import { addressFormatter } from 'core/helpers/formatters';
import useStyles from './contact-details.styles';

// The applicant's contact info, shown on every Offer tab so agents can reference it mid-quote
// (e.g. to quote elsewhere after a rejection) without reaching checkout. #33291
const ContactDetails = observer(() => {
  const classes = useStyles();
  const {
    offer: { offer }
  } = useStore();
  const { correctedAddress, farmLocations, email, phone, additionalPhoneNumbers } = offer.quote;
  // Farm offers may have no correctedAddress; their address lives on the farm locations.
  const address = [
    correctedAddress,
    ...(farmLocations ?? []).filter((location) => !location.isDeleted).map((location) => location.address)
  ].find((candidate) => candidate?.address);

  return (
    <>
      <Label type="subtitle" className={classes.header}>
        Contact details
      </Label>
      <Card id="offer_contact_details" className={classes.container}>
        <ValueField label="Address" value={address ? addressFormatter(address) : ''} />
        <ValueField label="Email" value={email} copyable={Boolean(email)} />
        <ValueField label="Phone" value={phone} copyable={Boolean(phone)} />
        {additionalPhoneNumbers?.map(({ phoneNumber }, index) => (
          <ValueField
            key={`${phoneNumber}-${index}`}
            label="Secondary phone"
            value={phoneNumber}
            copyable={Boolean(phoneNumber)}
          />
        ))}
      </Card>
    </>
  );
});

export default ContactDetails;
